export const AdTopLeaderboard = () => {
    return <div data-aaad="true" data-aa-adunit="/275516369/ImageResizer_TopLeaderboard"></div>;
};
